import { IResult, IGeometrySearchParameter } from "@/types/map";
import DrawOverlaysPGIS from "../../DrawOverlays/pgis/DrawOverlaysPGIS";
// import * as turf from "@turf/helpers";
import OverlayPGIS from "@/plugin/gis-viewer/widgets/Overlays/pgis/OverlayPGIS";
// import { feature } from "@turf/helpers";
// import { Emit, Vue } from "vue-property-decorator";
declare let ol: any;

export default class GeometrySearchPGIS {
  private static instances: Map<string, any>;
  private view!: any;
  private fmap!: any;
  private searchTypes: any[] = [];
  private searchGeometry!: any;
  private key!: string;
  private flashTime: number = 5;

  //替换查找结果的图标
  private _replaceTargetIcon: any;
  private _replacedTargets: Map<any, any>; //被替换图标的覆盖物和原图标

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;

    this._replacedTargets = new Map<any, any>();
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!GeometrySearchPGIS.instances) {
      GeometrySearchPGIS.instances = new Map();
    }
    let instance = GeometrySearchPGIS.instances.get(id);
    if (!instance) {
      instance = new GeometrySearchPGIS(view, fmap);
      GeometrySearchPGIS.instances.set(id, instance);
    }
    return instance;
  }

  public async clearGeometrySearch(): Promise<IResult> {
    this.searchGeometry = undefined;
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap);
    drawOverlays.deleteDrawOverlays({ types: ["geometrySearch"] });
    //还原替换的点位图标
    this._replacedTargets.forEach((style: any, feature: any) => {
      feature.setStyle(style);
    });
    this._replacedTargets.clear();

    return {
      status: 0,
      message: "成功调用clearGeometrySearch方法！"
    };
  }
  public async nearGeometrySearch(params: IGeometrySearchParameter) {
    let searchTypes = params.types || [];
    let returnResults = [];
    let pt = params.geometry; //geometry:[[]],{center:[],radius}

    let maxLen: number = params.maxLen || 10000000;
    let animation = params.animate !== false;
    const allOverlays = this.view.getOverlays();
    let inPolygonOverlays: any = {};

    const overlays = OverlayPGIS.getInstance(this.view, this.fmap);
    const layerGroups = overlays.layerGroups;
    let layerTypes: string[] = [];
    for (let type of layerGroups.keys()) {
      if (searchTypes.length == 0 || searchTypes.indexOf(type) > -1) {
        layerTypes.push(type);
      }
    }
    //无搜索类型限定，默认搜索全部
    for (let type of layerTypes) {
      let layer = layerGroups.get(type);
      const features = layer.getSource().getFeatures();
      for (let feature of features) {
        if (feature.getGeometry().getType() === "Point") {
          let type =
            feature.type || feature.attributes ? feature.attributes.type : "";
          if (type !== "") {
            let point = feature.getGeometry().getCoordinates();
            let dis = this.getDistance(point, [pt.x, pt.y]);
            if (inPolygonOverlays.hasOwnProperty(type)) {
              let currdis = inPolygonOverlays[type].dis;
              if (currdis > dis) {
                inPolygonOverlays[type] = { dis, overlay: feature };
              }
            } else {
              if (dis < maxLen) {
                inPolygonOverlays[type] = { dis, overlay: feature };
              }
            }
          }
        }
      }
    }

    return inPolygonOverlays;
  }
  public async backgroundGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    //await this.clearGeometrySearch();

    this.searchTypes = params.types || [];
    let searchGeometry = params.geometry;
    const animate = params.animate !== false;
    this._replaceTargetIcon = params.targetSymbol;

    if (Array.isArray(searchGeometry)) {
      if (
        !(
          searchGeometry[0][0] ===
          searchGeometry[searchGeometry.length - 1][0] &&
          searchGeometry[0][1] === searchGeometry[searchGeometry.length - 1][1]
        )
      ) {
        //首尾点不等情况，默认将第一个点推进数组
        searchGeometry.push([searchGeometry[0][0], searchGeometry[0][1]]);
      }
      //number[][]类型数据
      searchGeometry = new ol.geom.Polygon([searchGeometry]);
    }

    this.searchGeometry = searchGeometry;

    const inPolygonFeatures = await this.booleanContains();
    const returnResults: any = [];
    inPolygonFeatures.forEach((overlay: any) => {
      let returnOverlay: any = {};
      returnOverlay.attributes = overlay.attributes;
      returnOverlay.type = overlay.type || overlay.attributes.type || undefined;
      returnOverlay.id = overlay.id || overlay.attributes.id || undefined;
      returnOverlay.geometry = overlay.point;

      returnResults.push(returnOverlay);
    });

    //替换搜索结果图标
    if (this._replaceTargetIcon) {
      let rti = this._replaceTargetIcon;
      for (let i = 0; i < inPolygonFeatures.length; ++i) {
        let feature = inPolygonFeatures[i];
        let style_old = feature.getStyle();
        let style_new = style_old ? style_old.clone() : {};
        //只替换有图像的点位
        if (style_new.getImage()) {
          //获取图片的大小用于缩放
          let w = await this.getImageWidth(rti.url);
          let img = new ol.style.Icon({
            src: rti.url,
            // size: rti.size || [rti.width, rti.height],
            scale: rti.width ? rti.width / w : rti.size[0] / w,
          });
          style_new.setImage(img);
          feature.setStyle(style_new);
          this._replacedTargets.set(feature, style_old);
        }
      };
    }

    let _this = this;
    if (animate) {
      for (let feature of inPolygonFeatures) {
        animateFeature(feature);
      }
    }

    if (inPolygonFeatures.length === 1) {
      console.log(inPolygonFeatures[0].getGeometry());
      await this.view.getView().fit(inPolygonFeatures[0].getGeometry(), {
        duration: 1000
      });
    }

    async function animateFeature(feature: any) {
      const curStyle = feature.getStyle();

      feature.setStyle(null);
      for (let i = 0; i < _this.flashTime; i++) {
        await sleep(250);
        feature.setStyle(curStyle);
        await sleep(250);
        feature.setStyle(null);
      }
      feature.setStyle(curStyle);
    }

    function sleep(params: number) {
      let promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve(null);
        }, params);
      });

      return promise;
    }

    return {
      message: "no complete",
      status: 0,
      result: returnResults.length ? JSON.stringify(returnResults) : null
    };
  }

  public async startGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    const drawType = params.drawType || "polygon";
    const pointsType = params.types || [];
    // this.key = params.key || "";
    this.searchTypes = pointsType;
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap);
    //清除已有的几何查找图形
    await drawOverlays.deleteDrawOverlays({ types: ["geometrySearch"] });

    let doDrawOverlays = await drawOverlays.startDrawOverlays({
      drawType: drawType,
      type: "geometrySearch",
    });
    //绘制的几何图形用于几何查找
    // const searchGeometry = drawOverlays.curResult.overlay;
    const searchGeometry = doDrawOverlays.result.overlay;
    const bgSearchArgs = {
      types: this.searchTypes,
      geometry: searchGeometry,
      ...params,
    };

    let result = new Promise<IResult>((resolve, reject) => {
      const bgSearchResults = this.backgroundGeometrySearch(bgSearchArgs);
      bgSearchResults.then((bgSearchResults): any => {
        const resultsArray = JSON.parse(bgSearchResults.result);
        resolve({
          status: 0,
          message: "成功调用startGeometrySearch方法！",
          result:
            resultsArray && resultsArray.length ? JSON.stringify(resultsArray) : "未搜索到任何覆盖物",
        });
      }).catch((err: any) => {
        reject({
          status: -1,
          message: "调用startGeometrySearch方法错误！",
          result: err,
        });
      });
    });
    return result;
  }

  public async startSearchByKey(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    this.key = params.key || "";

    if (!this.searchGeometry && this.key == "") {
      return {
        message: "no overlays",
        status: 0
      };
    }
    const inPolygonFeatures = await this.booleanContains();
    const returnResults: any = [];
    inPolygonFeatures.forEach((overlay: any) => {
      let returnOverlay: any = {};
      returnOverlay.attributes = overlay.attributes;
      returnOverlay.type = overlay.type || overlay.attributes.type || undefined;
      returnOverlay.id = overlay.id || overlay.attributes.id || undefined;
      returnOverlay.geometry = overlay.point;

      returnResults.push(returnOverlay);
    });
    let _this = this;
    for (let feature of inPolygonFeatures) {
      animateFeature(feature);
    }
    if (inPolygonFeatures.length === 1) {
      console.log(inPolygonFeatures[0].getGeometry());
      await this.view.getView().fit(inPolygonFeatures[0].getGeometry(), {
        duration: 1000
      });
    }

    async function animateFeature(feature: any) {
      const curStyle = feature.getStyle();

      feature.setStyle(null);
      for (let i = 0; i < _this.flashTime; i++) {
        await sleep(250);
        feature.setStyle(curStyle);
        await sleep(250);
        feature.setStyle(null);
      }
      feature.setStyle(curStyle);
    }

    function sleep(params: number) {
      let promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve(null);
        }, params);
      });

      return promise;
    }

    return {
      message: "no complete",
      status: 0,
      result: returnResults.length ? JSON.stringify(returnResults) : null
    };
  }
  private async booleanContains(): Promise<any> {
    const inPolygonFeatures = [];

    const overlays = OverlayPGIS.getInstance(this.view, this.fmap);
    const layerGroups = overlays.layerGroups;
    //无搜索类型限定，默认搜索全部
    if (!this.searchTypes.length) {
      for (let layer of layerGroups.values()) {
        const features = layer.getSource().getFeatures();
        for (let feature of features) {
          if (feature.getGeometry().getType() === "Point") {
            if (
              this.searchGeometry == undefined ||
              (this.searchGeometry &&
                this.searchGeometry.intersectsCoordinate(
                  feature.getGeometry().getCoordinates()
                ))
            ) {
              if (this.searchPointField(this.key, feature.attributes)) {
                inPolygonFeatures.push(feature);
              }
            }
          }
        }
      }
    } else {
      for (let searchType of this.searchTypes) {
        const layerOfType = layerGroups.get(searchType);
        if (!layerOfType) {
          continue;
        }
        const features = layerOfType.getSource().getFeatures();
        for (let feature of features) {
          if (
            searchType === feature.type ||
            searchType === feature.attributes.type
          ) {
            if (
              this.searchGeometry == undefined ||
              (this.searchGeometry &&
                this.searchGeometry.intersectsCoordinate(
                  feature.getGeometry().getCoordinates()
                ))
            ) {
              if (this.searchPointField(this.key, feature.attributes)) {
                inPolygonFeatures.push(feature);
              }
            }
          }
        }
      }
    }

    return inPolygonFeatures;
  }

  private searchPointField(key: string | undefined, attr: any) {
    if (key == undefined || key == "") {
      return true;
    } else {
      for (let field in attr) {
        if (typeof attr[field] == "string") {
          if (attr[field].toString().indexOf(key) > -1) {
            return true;
          }
        }
      }
    }
    return false;
  }
  private getDistance(pt1: number[], pt2: number[]) {
    let paths = [pt1, pt2];
    const geom = new ol.geom.LineString(paths);
    return this.formatLength(geom);
  }
  private formatLength(line: any) {
    //定义长度变量
    let length;
    //计算平面距离
    length =
      Math.round(
        ol.sphere.getLength(line, {
          projection: "EPSG:4326"
        }) * 100
      ) / 100;
    //定义输出变量
    var output;
    //如果长度大于1000，则使用km单位，否则使用m单位
    output = Math.round(length * 100) / 100; //m为单位
    return output;
  }
  private async getImageWidth(url: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const image = new Image();
      image.src = url;
      image.onload = function () {
        let width = image.width;
        resolve(width);
      };
      image.onerror = function () {
        reject(1);
      };
    });
  }
}
